import React from 'react'
import KonfhubContainer from '../Atom/Container'
import { FilePreview } from 'kh-design-system/components'
import StatusInput from '../Atom/Input/StatusInput';
import { successToaster, errorToaster } from '../../reusable/common';
import { updateTaskStatus } from '../../revampCRUD/taskManagement.crud';
import { ErrMessages, CrudMessages } from '../../revampPages/EventInfo/config/error-constants';
import { TASK_TYPE } from '../../revampPages/EventInfo/config/constants';
import { isImageFile } from '../../reusable/common';
import { dashboardColors, theme } from '../../themes/Theme';

const TaskStatusUpdate = ({ data, exhibitorId, filterTaskType, filterTaskId, filterTitle, filterDescription, filterTaskColumnMapping }) => {

    const taskStatus = data?.task_status || "";
    const taskColomnMapping = filterTaskColumnMapping || "";

    const handleStatusChange = (selectedOption) => {
        const payload = {
            task_title: filterTitle,
            task_status: selectedOption.value,
            task_column_mapping: taskColomnMapping
        };

        const taskId = filterTaskId;
        const assignmentId = data?.assignment_id;

        updateTaskStatus(exhibitorId, taskId, assignmentId, payload)
            .then((response) => {
                successToaster(CrudMessages.UPDATE_MESSAGE);
            })
            .catch((error) => {
                errorToaster(ErrMessages.DEFAULT_ERROR_MESSAGE);
            });
    };

    const downloadFile = (url) => {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <KonfhubContainer>
                <div className="d-flex flex-row w-100 align-items-center">
                    <span className="update-text">Update Status</span>
                    <div style={{ width: "130px" }}>
                        <StatusInput onChangeHandle={handleStatusChange} value={taskStatus} width='120px' />
                    </div>
                </div>
                <div className="mt-3 d-flex flex-column">
                    <span className="update-text mb-2">{filterTitle}</span>
                    <span className='description-text' dangerouslySetInnerHTML={{ __html: filterDescription }} />
                </div>
                {((filterTaskType === TASK_TYPE?.FILE && data?.response_files.length > 0) || (filterTaskType === TASK_TYPE?.TEXT && data?.task_response)) &&
                    <div className='mt-3 d-flex flex-column'>
                        <span className="update-text mb-1">Response from AWS</span>
                        {filterTaskType === TASK_TYPE.FILE &&
                            <div className="d-flex flex-wrap">
                                {data?.response_files.map((file, index) => (
                                    <FilePreview
                                        key={index}
                                        url={file.url}
                                        handleDownload={() => downloadFile(file.url)}
                                        containerStyle={{
                                            width: '145px',
                                            height: '100px',
                                            cursor: "pointer",
                                            margin: "7px"
                                        }}
                                        downloadIconColor="#4C585B"
                                        showDeleteButton={false}
                                        showDownloadButton={true}
                                        isImage={isImageFile(file.url)}
                                    />
                                ))}
                            </div>
                        }
                        {filterTaskType === TASK_TYPE.TEXT &&
                            <div className="d-flex flex-wrap description-text" dangerouslySetInnerHTML={{ __html: data?.task_response }} />
                        }
                    </div>
                }
            </KonfhubContainer>
            <style jsx>{`
            .update-text{
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                color: ${dashboardColors[theme].primaryTextColor};
                margin-right: 10px;
            }
            .description-text{
                font-size: 15px;
                font-weight: 400;
                line-height: 20px;
                color: ${dashboardColors[theme].primaryTextColor};
            }
        `}</style>
        </>
    )
}

export default TaskStatusUpdate